import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "ticketino-api-client";
import { OrganizerWithUsernameAlreadyExists } from "../../utils/api";
import { useLanguage } from "../../hooks/useLanguage";

import Header from "../components/Header";
import Footer from "../components/Footer";

const AccountUsername = () => {
    const [regularToken, setRegularToken] = useState(null);
    const [username, setUsername] = useState('');
    const [error, setError] = useState('');

    const [resources, setResources] = useState({});
    const { language } = useLanguage();

    const navigate = useNavigate();
    let baseUrl = process.env.REACT_APP_BASEURL_API;
    api.defaults.baseURL = baseUrl;

    useEffect(() => {
        // Clear any old authentication tokens from previous sessions
        localStorage.removeItem("buyerToken");
        localStorage.removeItem("username");
        localStorage.removeItem("loggedInOrganizerId");
        localStorage.removeItem("loginDateTime");
        localStorage.removeItem("accountRegistrationEmail");
        localStorage.removeItem("accountLoginUserId");
        
        loadToken();
    }, []);

    useEffect(() => {
        requestResources();
    }, [language]);

    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;

            localStorage.setItem("token", res.data);
            setRegularToken(res.data);

            requestFormSettings();
        });
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            //setPosId(res.data.posId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const requestConfirmationCode = async (username) => {
        return await axios
            //.post(`https://localhost:44317/Account/RegisterExternal?username=${username}`)
            .post(`https://accounts.ticketino.com/Account/RegisterExternal?username=${username}`)
            .catch((error) => console.error(error.response.data));
    };

    // Simple email validation regex
    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handleCheckUsername = async (e) => {
        e.preventDefault();

        if (!isValidEmail(username)) {
            setError("Please enter a valid email address.");
            return;
        }

        setError(""); // Clear error if valid

        try {
            const usernameAlreadyExists = await fetchOrganizerWithUsernameAlreadyExists(username);

            localStorage.setItem("accountRegistrationEmail", username); // Save username for account registration

            if (usernameAlreadyExists) {
                // User already exists, redirect to login
                navigate(`/${language}/account-login`);
            } else {
                // New user, send confirmation code
                const res = await requestConfirmationCode(username);
                const loginUserId = res.data;

                // Store loginUserId for next step 
                localStorage.setItem("accountLoginUserId", loginUserId);

                navigate(`/${language}/account-confirmation-code`);
            }
        } catch (err) {
            console.error('username check failed:', err.response?.data || err.message);
        }
    };

    const fetchOrganizerWithUsernameAlreadyExists = async (username) => {
        try {
            if (!regularToken) {
                throw new Error("No token found at fetchOrganizerWithUsernameAlreadyExists");
            }
            const data = await OrganizerWithUsernameAlreadyExists(baseUrl, "token", regularToken, username);

            return data;
        } catch (error) {
            console.error('Error fetching organizer with username already exists:', error);
        }
    };

    return (
        <>
            <Header language={language} pagePath="login" pageTitle={resources?.RegistrationTitle}
                ticketCount={0} />

            <div className="page-container">

                <div className="container wrapper">

                    {/* navigation */}
                    <div className="row mb-4">
                        <div className="col-6">
                            <button className="btn-custom  btn-navigation" type="submit">
                                {resources?.Account_LoginRegister}
                            </button>
                        </div>
                        <div className="col-6 text-end">
                            <button className="btn-custom transparent btn-navigation" type="submit"
                                onClick={() => navigate(`/${language}/account-login`)}>
                                {resources?.Account_LoginLogin}
                            </button>
                        </div>
                    </div>

                    {/* inputs */}
                    <form onSubmit={handleCheckUsername}>
                        <div className="form-group row">
                            <label htmlFor="staticEmail" className="col-sm-12 col-form-label">{resources?.Account_UsernameEmail}</label>
                            <div className="col-sm-12">
                                <input
                                    className="form-control"
                                    name="username"
                                    value={username}
                                    onChange={(e) => {
                                        setUsername(e.target.value);
                                        if (error && isValidEmail(e.target.value)) setError('');
                                    }}
                                />
                                {error && (
                                    <div className="text-danger mt-2 fw-bold">{error}</div>
                                )}
                            </div>
                        </div>

                        {/* button */}
                        <div className="row mt-5">
                            <div className="col-md-12 text-center">
                                <button className="btn-custom btn-navigation" type="submit">{resources?.UsernameLogin}</button>
                            </div>
                        </div>

                        {/* Already have account */}
                        <div className="row mt-4 text-center">
                            <div className="col-md-12 d-flex flex-column">
                                <span><b>{resources?.Account_RegistrationAlreadyRegistered}</b></span>
                                <span>
                                    {resources?._Click}
                                    <button
                                        type="button"
                                        style={{ background: "none", border: "none", color: "inherit", textDecoration: "underline", cursor: "pointer" }}
                                        onClick={() => navigate(`/${language}/account-login`)}
                                    >
                                        {resources?._Here}
                                    </button>
                                    {resources?.Account_LoginAlreadyHasAccountDesc}
                                </span>
                            </div>
                        </div>
                    </form>
                </div>

            </div>

            <Footer language={language} />
        </>
    )
}

export default AccountUsername;
